import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const getSede = async (sede_id) => {
  return await axiosIns.get(obtenerUrl(`cuentas-pagadoras?sede_id=${sede_id}`));
};

const get = async () => {
  return await axiosIns.get(obtenerUrl(`cuentas-pagadoras`));
};

const store = async (data) => {
  return await axiosIns.post(obtenerUrl(`cuentas-pagadoras`), data);
};

const update = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`cuentas-pagadoras/${id}`), data);
};

const destroy = async (id) => {
  return await axiosIns.delete(obtenerUrl(`cuentas-pagadoras/${id}`));
};

export default {
  get,
  store,
  update,
  destroy,
  getSede,
};
